var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgB2B = function SvgB2B(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 273,
    height: 209,
    viewBox: "0 0 273 209"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 209h272.752V.12H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C1DDD4",
    d: "M143 197h59V99.68L172.5 81 143 99.68zM21 197h59v-75.178L50.5 103 21 121.822z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9BBCAD",
    d: "M47 184h7v-12h-7zM47 161h7v-12h-7zM47 138h7v-12h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEC8BD",
    d: "M77 197h62V20H77z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#413F3F",
    d: "M147.11 51.432v-6.968c.307-.328.495-.769.495-1.254h.494v9.436h-.495a1.83 1.83 0 0 0-.493-1.214M134.932 52.646v-9.435h.494c0 .485.188.925.494 1.254v6.966a1.83 1.83 0 0 0-.493 1.215h-.495z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#623721",
    d: "M102.908 184.371h6.534V172.01h-6.534z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452514",
    d: "M124.74 184.371h6.534V172.01h-6.534zM95.26 196.972h65.495v-6.503H95.259z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D05E2D",
    d: "M102.908 184.371h6.534V172.01h-6.534v12.362zm-7.649 6.098h21.832v-22.72H95.259v22.72z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B14518",
    d: "M124.74 184.371h6.534V172.01h-6.534v12.362zm-7.649 6.098h21.832v-22.72H117.09v22.72z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#853716",
    d: "M146.572 184.371h6.534V172.01h-6.534v12.362zm-7.65 6.098h21.833v-22.72h-21.832v22.72z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E37949",
    d: "M102.908 161.65h6.534v-12.362h-6.534v12.362zm-7.649 6.098h21.832v-22.72H95.259v22.72z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D05E2D",
    d: "M124.74 161.65h6.534v-12.362h-6.534v12.362zm-7.649 6.098h21.832v-22.72H117.09v22.72z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B14518",
    d: "M146.572 161.65h6.534v-12.362h-6.534v12.362zm-7.65 6.098h21.833v-22.72h-21.832v22.72z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE4D3",
    d: "M102.908 138.93h6.534v-12.363h-6.534v12.362zm-7.649 6.097h21.832v-22.72H95.259v22.72z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E37949",
    d: "M124.74 138.93h6.534v-12.363h-6.534v12.362zm-7.649 6.097h21.832v-22.72H117.09v22.72z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D05E2D",
    d: "M146.572 138.93h6.534v-12.363h-6.534v12.362zm-7.65 6.097h21.833v-22.72h-21.832v22.72z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A49E9A",
    d: "M146.572 116.209h6.534v-12.363h-6.534v12.363zm-21.832 0h6.534v-12.363h-6.534v12.363zm14.183-16.623h21.832v22.72H117.09v-22.72h21.832z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M95.26 99.586h21.83v22.72h-1.902v-19.431H97.162v19.431h-1.903zM138.923 76.865h21.832v22.72h-1.903V80.155h-18.026v19.432h-3.806V80.154h-18.026v19.432h-1.903v-22.72z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#301C12",
    d: "M146.572 184.371h6.534V172.01h-6.534z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#714028",
    d: "M102.908 161.65h6.534v-12.362h-6.534z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#623721",
    d: "M124.74 161.65h6.534v-12.362h-6.534z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#452514",
    d: "M146.572 161.65h6.534v-12.362h-6.534z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C5755",
    d: "M102.908 138.93h6.534v-12.363h-6.534z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#714028",
    d: "M124.74 138.93h6.534v-12.363h-6.534z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#623721",
    d: "M146.572 138.93h6.534v-12.363h-6.534z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A5D5D",
    d: "M268.823 196.971c2.177-.027 3.93 1.764 3.93 3.926a3.926 3.926 0 0 1-3.928 3.926H3.942C1.775 204.85 0 203.05 0 200.897c0-2.152 1.775-3.954 3.942-3.926h264.881z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4D596",
    d: "M106.842 202.734h64.553c1.145-.03 2.091.965 2.091 2.089a2.089 2.089 0 0 1-2.09 2.088h-64.554a2.088 2.088 0 1 1 0-4.177",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6988F",
    d: "M32.901 201.257h58.32a3.566 3.566 0 1 1 0 7.13H32.888a3.565 3.565 0 1 1 0-7.13h.013z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E37949",
    d: "M133.374 27.085a3.151 3.151 0 1 1 .001 6.302 3.151 3.151 0 0 1-.001-6.302M13.22 36.3a3.151 3.151 0 1 1 .002 6.302 3.151 3.151 0 0 1-.002-6.302M56.896.12a3.151 3.151 0 1 1 .001 6.303A3.151 3.151 0 0 1 56.896.12",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004073",
    d: "M55.903 183.318a.99.99 0 0 1 .29-.702l9.94-11.96h-9.237a.993.993 0 0 1-.702-1.693l9.94-11.96h-9.238a.993.993 0 0 1-.702-1.694l9.94-11.96h-9.238a.993.993 0 0 1-.702-1.694l9.94-11.96h-9.238a.993.993 0 0 1-.702-1.694l9.94-11.96h-9.238a.993.993 0 0 1-.702-1.693l9.94-11.96h-9.238a.993.993 0 0 1-.958-1.253.987.987 0 0 1 .198-.875l9.997-12.029h-9.237a.993.993 0 0 1-.702-1.694l9.94-11.96h-9.238a.993.993 0 0 1-.702-1.693l11.289-13.585a.988.988 0 0 1 1.52 1.264l-9.997 12.03h9.237a.993.993 0 0 1 .702 1.693l-9.94 11.96h9.238a.993.993 0 0 1 .702 1.694L58.59 100.402h9.654a.993.993 0 0 1 .702 1.694l-9.94 11.96h9.238a.992.992 0 0 1 .702 1.694l-9.94 11.96h9.238a.992.992 0 0 1 .702 1.694l-9.94 11.96h9.238a.992.992 0 0 1 .702 1.694l-9.94 11.96h9.238a.993.993 0 0 1 .702 1.693l-9.94 11.961h9.238a.992.992 0 0 1 .702 1.694l-9.94 11.96h9.238c.548 0 .993.443.993.992H55.903zM150.65 39.45a.993.993 0 0 1-1.986 0v-7.515l-14.736 8.339a.993.993 0 0 1-1.547-.823v-7.516l-14.736 8.339a.993.993 0 0 1-1.547-.823v-7.516l-14.736 8.339a.992.992 0 0 1-1.547-.823v-7.516L85.08 40.274a.993.993 0 0 1-1.547-.823v-9.215a.993.993 0 0 1 1.985 0v7.516l14.736-8.34a.993.993 0 0 1 1.547.823v7.517l14.736-8.34a.993.993 0 0 1 1.547.823v7.517l14.736-8.34a.993.993 0 0 1 1.547.823v7.517l14.736-8.34a.993.993 0 0 1 1.547.823v9.215zM69.003 38.819a.989.989 0 0 1-1.52 1.263l-11.29-13.584a.992.992 0 0 1 .702-1.693h7.066a.992.992 0 0 1 0 1.984h-4.955l9.997 12.03zM24.885 29.412l14.735 8.34v-7.516a.993.993 0 0 1 1.986 0v9.214a.992.992 0 0 1-1.547.824l-14.736-8.34v7.516a.993.993 0 0 1-1.985 0v-9.214a.993.993 0 0 1 1.547-.824",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0171B7",
    d: "M57.938 38.409h8.888l-8.888-28.337v28.337zM67.2 183.317V40.493h-9.262v142.824h-2.084V3.271a1.042 1.042 0 0 1 2.054-.25l11.099 35.388h.278V183.317H67.2z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0171B7",
    d: "M149.388 31.278H84.794l-12.6 7.13h89.795l-12.6-7.13zm-65.444-1.906c.166-.113.366-.178.581-.178h65.132c.215 0 .415.065.581.178l16.143 9.134a1.042 1.042 0 0 1-.442 1.987H64.292l3.438-1.946 16.214-9.175zM52.945 38.409l-12.6-7.131h-15.64l-8.598 7.13h36.838zm-40.35.207l11.032-9.149c.185-.17.432-.273.704-.273h16.282c.216 0 .416.065.582.177l16.143 9.136a1.041 1.041 0 0 1-.442 1.986H13.22a1.042 1.042 0 0 1-.624-1.877z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004073",
    d: "M72.241 59.931h-13.67a1.68 1.68 0 0 1-1.675-1.674V41.125c0-.921.754-1.675 1.675-1.675h13.67a1.68 1.68 0 0 1 1.675 1.675v17.132a1.68 1.68 0 0 1-1.675 1.674",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#413F3F",
    d: "M11.427 36.86L54.685 1.026a3.137 3.137 0 0 0-.935 2.061L13.625 36.326a3.138 3.138 0 0 0-2.198.534M58.23.415l75.9 26.761a3.187 3.187 0 0 0-2.22.269L59.788 2.015a3.163 3.163 0 0 0-1.557-1.6z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D9D9D",
    d: "M23.338 49.696h9.134v-9.214h-9.134zM51.223 196.971h22.693v-13.654H51.223z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A6969",
    d: "M32.472 49.696h9.135v-9.214h-9.135z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M67.2 59.931v-20.48h5.041a1.68 1.68 0 0 1 1.675 1.674v17.132a1.68 1.68 0 0 1-1.675 1.674h-5.04z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0171B7",
    d: "M73.916 54.433h-9.712a.954.954 0 0 1-.952-.951v-9.733c0-.523.429-.95.952-.95h9.712v11.634z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004073",
    d: "M67.2 54.433h6.716V42.8H67.2z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E37949",
    d: "M134.353 55.71l7.162 2.942v-6.006h-7.162z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#853716",
    d: "M143.428 57.866a2.978 2.978 0 1 1-4.89 2.282h1.48a1.497 1.497 0 1 0 1.497-1.497l1.913-.785z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAA",
    d: "M132.381 43.21h9.134v-2.718h-9.134z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B14518",
    d: "M148.678 55.71l-7.163 2.942v-6.006h7.163z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A6969",
    d: "M141.515 43.21h9.134v-2.718h-9.134z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E37949",
    d: "M137.264 50.848c1.003 0 1.818.801 1.839 1.798h-3.677a1.838 1.838 0 0 1 1.838-1.798M145.766 50.848c1.003 0 1.817.801 1.838 1.798h-3.676a1.838 1.838 0 0 1 1.838-1.798M139.103 43.21a1.838 1.838 0 0 1-3.677 0h3.677zM147.605 43.21a1.838 1.838 0 0 1-3.677 0h3.677z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#853716",
    d: "M137.264 42.318a.893.893 0 1 1 .001 1.785.893.893 0 0 1 0-1.785M137.264 51.754a.893.893 0 1 1 .001 1.785.893.893 0 0 1 0-1.785M145.766 42.318a.893.893 0 1 1 .001 1.785.893.893 0 0 1 0-1.785M145.766 51.754a.893.893 0 1 1 .001 1.785.893.893 0 0 1 0-1.785",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C6966",
    d: "M156.988 76.865v3.289h-7.65v-1.928h-6.533v1.928h-1.98v16.533h-3.805V76.865z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A49E9A",
    d: "M138.249 85.939h6.534V73.576h-6.534V85.94zm-7.65 6.097h21.832v-22.72h-21.832v22.72z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#413F3F",
    d: "M130.9 69.71a.495.495 0 0 1-.601-.787l10.916-8.366a.495.495 0 0 1 .6.787L130.9 69.71z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#413F3F",
    d: "M141.215 61.344a.495.495 0 1 1 .6-.787l10.917 8.366a.495.495 0 1 1-.601.787l-10.916-8.366z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0A0A0",
    d: "M12.917 176.046v20.925h-.991v-19.935c0-.547.443-.99.99-.99",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535252",
    d: "M12.917 176.046c.547 0 .99.443.99.99v19.935h-.99v-20.925z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0A0A0",
    d: "M32.901 176.046v20.925h-.991v-19.935c0-.547.444-.99.991-.99",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535252",
    d: "M32.901 176.046a.99.99 0 0 1 .991.99v19.935h-.991v-20.925z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B30000",
    d: "M35.874 179.345v5.823c-.001.718-.584 1.306-1.3 1.318h-3.022l4.053-7.934c.168.22.269.496.269.793",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M35.606 178.551l-4.054 7.935H27.23l4.322-8.46h3.002c.428 0 .81.207 1.052.525",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B30000",
    d: "M31.552 178.027l-4.321 8.459h-4.322l4.322-8.46z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.909 178.027h4.321l-4.321 8.459h-4.321z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B30000",
    d: "M18.587 178.027h4.322l-4.322 8.459h-4.321z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.266 178.027h4.321l-4.321 8.459h-3.01a1.32 1.32 0 0 1-1.044-.525l4.054-7.934z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B30000",
    d: "M9.944 185.167v-5.82c0-.723.59-1.315 1.31-1.32h3.011l-4.053 7.934a1.307 1.307 0 0 1-.268-.794",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0A0A0",
    d: "M32.901 193.01H12.916a.99.99 0 0 1 .991-.99H31.91a.99.99 0 0 1 .991.99",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535252",
    d: "M32.901 193.01a.99.99 0 0 1-.991.99H13.907a.991.991 0 0 1-.99-.99H32.9z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95B4A6",
    d: "M168.8 184.33h6.534v-12.362H168.8zM168.8 161.61h6.534v-12.363H168.8zM168.8 138.89h6.534v-12.363H168.8z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0A0A0",
    d: "M174.494 176.046v20.925h-.99v-19.935c0-.547.443-.99.99-.99",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535252",
    d: "M174.494 176.046a.99.99 0 0 1 .99.99v19.935h-.99v-20.925z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0A0A0",
    d: "M194.479 176.046v20.925h-.991v-19.935a.99.99 0 0 1 .991-.99",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535252",
    d: "M194.479 176.046a.99.99 0 0 1 .99.99v19.935h-.99v-20.925z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B30000",
    d: "M197.451 179.345v5.823a1.324 1.324 0 0 1-1.3 1.318h-3.021l4.053-7.934c.168.22.268.496.268.793",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M197.183 178.551l-4.053 7.935h-4.322l4.322-8.46h3.001c.428 0 .81.207 1.052.525",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B30000",
    d: "M193.13 178.027l-4.322 8.459h-4.322l4.322-8.46z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M184.486 178.027h4.321l-4.32 8.459h-4.322z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B30000",
    d: "M180.165 178.027h4.321l-4.321 8.459h-4.322z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M175.843 178.027h4.322l-4.322 8.459h-3.009a1.32 1.32 0 0 1-1.044-.525l4.053-7.934z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B30000",
    d: "M171.522 185.167v-5.82c0-.723.589-1.315 1.31-1.32h3.01l-4.052 7.934a1.31 1.31 0 0 1-.268-.794",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0A0A0",
    d: "M194.479 193.01h-19.985a.99.99 0 0 1 .99-.99h18.004a.99.99 0 0 1 .991.99",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535252",
    d: "M194.479 193.01c0 .546-.444.99-.991.99h-18.003a.99.99 0 0 1-.99-.99h19.984z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95B4A6",
    d: "M168.8 116.169h6.534v-12.363H168.8z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2FFFA",
    d: "M258.755 48.985c1.722 1.352 2.038 3.822.707 5.515-1.332 1.694-3.807 1.97-5.529.617s-2.038-3.823-.707-5.516c1.332-1.693 3.807-1.97 5.53-.616M239.75 34.97c1.532 1.204 2.365 3.052 2.52 5.187 3.154-2.422 6.858-3.003 9.213-1.153 3.022 2.374 2.677 7.854-.771 12.239-2.379 3.024-5.61 4.732-8.38 4.731h-13.76c-1.598 0-3.078-.41-4.276-1.35-1.116-.877-1.861-2.097-2.243-3.52a11.39 11.39 0 0 1-.817 1.184c-2.686 3.416-6.772 4.686-9.126 2.837-2.354-1.85-2.085-6.119.6-9.535 2.687-3.416 6.773-4.686 9.127-2.836.368.29.672.637.913 1.032a17.416 17.416 0 0 1 2.502-4.31c4.267-5.427 10.759-7.445 14.498-4.506M203.761 20.493c2.507 1.97 3.048 5.752 1.731 9.622 1.617-.824 3.306-.876 4.46.032 1.844 1.448 1.634 4.79-.47 7.464-2.102 2.675-5.302 3.669-7.144 2.22-.855-.671-1.268-1.751-1.255-2.982-2.459 2.297-5.345 3.647-7.916 3.646l-13.5-.005c-.832 0-1.597-.305-2.23-.803-2.242-1.761-1.987-5.826.572-9.08 2.558-3.254 6.45-4.463 8.691-2.701.35.275.64.607.87.983a16.551 16.551 0 0 1 2.382-4.104c4.065-5.17 10.247-7.09 13.81-4.292",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8AA50",
    d: "M150.445 204.823c1.161-.015 2.091.936 2.091 2.088a2.089 2.089 0 0 1-2.09 2.089h-22.522a2.089 2.089 0 1 1 .008-4.177h22.513zM163.184 204.823c1.16-.015 2.09.936 2.09 2.088a2.088 2.088 0 0 1-2.089 2.089h-5.578a2.089 2.089 0 1 1 .008-4.177h5.569z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4D596",
    d: "M55.854 196.971c5.986-10.93 17.274-16.683 25.725-16.683v16.683H55.854z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8AA50",
    d: "M107.304 196.971c-5.986-10.93-17.274-16.683-25.725-16.683v16.683h25.725zM74.438 189.272a.837.837 0 1 1 0 1.674.837.837 0 0 1 0-1.674M69.774 186.59a.538.538 0 1 1 0 1.075.538.538 0 0 1 0-1.075M77.159 193.194a1.14 1.14 0 1 1 0 2.279 1.14 1.14 0 0 1 0-2.279M67.972 193.515a.806.806 0 1 1 0 1.611.806.806 0 0 1 0-1.611",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4D596",
    d: "M85.302 191.933a.806.806 0 1 1 0 1.611.806.806 0 0 1 0-1.611M88.772 193.784a.55.55 0 1 1 0 1.102.55.55 0 0 1 0-1.102",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8AA50",
    d: "M69.339 191.98a.537.537 0 1 1 .002 1.073.537.537 0 0 1-.002-1.073M73.126 193.686a.538.538 0 1 1 0 1.075.538.538 0 0 1 0-1.075M63.104 192.5a.538.538 0 1 1 0 1.076.538.538 0 0 1 0-1.075",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383838",
    d: "M148.326 133.814l-.49 3.192a1.711 1.711 0 1 1-2.862 1.775l-.034-.093-14.497.086 4.475-8.494c1.815-2.632 5.185-3.186 7.717-.98l1.822 2.474 1.37-.302a1.714 1.714 0 0 1 2.827.566 1.71 1.71 0 0 1-.328 1.776",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M128.21 141.588l3.447-6.282.706-.176-1.92 3.644 1.871-.011-1.789 2.054z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M157.707 125.715l-2.284 1.301a1.703 1.703 0 0 1 .759 1.328l2.283-1.3-.758-1.33z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0171B7",
    d: "M148.77 132.57l4.124-2.351.279-.664a1.714 1.714 0 0 1-.411-1.023l-4.748 2.708a1.712 1.712 0 0 1 .756 1.33",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M190.123 119.22l5.058 3.82.921-1.222-5.056-3.818a2.555 2.555 0 0 1-.923 1.22",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004073",
    d: "M180.525 126.392l-32.549 12.74a1.71 1.71 0 0 0-.14-2.126l.225-1.467 3.525-2.209-.302.718a1.71 1.71 0 1 0 .735 3.303 1.712 1.712 0 0 0 .676-2.71l1.145-2.723 17.427-10.922 9.177-5.75 6.305.136a2.567 2.567 0 0 0 1.639 4.307l-4.654 4.323-2.136-1a1.711 1.711 0 1 0-1.76 2.937l.687.443z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353635",
    d: "M223.722 160.684l11.336-.693c1.29-.08 2.106.58 2.298 1.652l.086.475-15.94.495.153-.473c.247-.762 1.032-1.393 2.067-1.456",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M224.07 185.646h17.383v-1.33H224.07z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01182B",
    d: "M264.717 181.677v.923c0 .944-.773 1.717-1.717 1.717h-42.058c-.944 0-1.63-.777-1.717-1.717l-.086-.923h45.578z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004073",
    d: "M239.035 171.005h22.081c1.876-.013 2.682 1.083 2.989 3.257l.611 5.41v2.005h-25.68v-10.672z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M252.444 172.399h7.534c.532 0 .922.436.966.965l.43 5.19c.043.53-.435.966-.966.966h-10.562l2.598-7.121z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0171B7",
    d: "M243.969 171.005h8.983l-3.893 10.672h-8.983z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353635",
    d: "M248.777 172.399h3.667l-2.598 7.121h-1.069a.968.968 0 0 1-.965-.965v-5.191c0-.531.434-.965.965-.965M243.523 171.005h1.964v-2.585h-1.964z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M242.708 168.42h3.595v-1.28h-3.595z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353635",
    d: "M246.302 167.14c0-.708-.804-1.28-1.797-1.28-.992 0-1.797.572-1.797 1.28h3.594z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E4E4E",
    d: "M221.506 162.612l-.005-.153-2.314.073.26 8.167c.442-2.57 1.168-5.337 2.056-8.086h.003z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBCBCB",
    d: "M221.126 162.471l-.619-15.058a2.584 2.584 0 0 1-1.53.063l.618 15.044 1.53-.049z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0171B7",
    d: "M181.5 125.3a1.136 1.136 0 0 1-1.569-1.641 1.136 1.136 0 0 1 1.569 1.642m.098-2.288l34.417 16.094c8.964 4.197 12.934 11.45 13.915 19.626l.224 1.56-6.452.406-.015-.041c-.69-1.778-1.666-3.496-2.847-5.137l-.333-8.108a2.566 2.566 0 0 0 1.017-4.164 2.569 2.569 0 1 0-2.546 4.227l.246 5.991c-3.114-3.646-7.157-6.835-11.16-9.345l-28.226-18.172a1.71 1.71 0 0 1-.288-2.725 1.715 1.715 0 0 1 2.048-.212",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E4E4E",
    d: "M194.944 123.354l15.173 11.433.763-.939.033-.04v-.001l.004-.004a2.133 2.133 0 0 1 .9-.634l-15.48-11.664-1.393 1.85z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004073",
    d: "M213.33 136.009a1.135 1.135 0 1 1-1.545-1.664 1.135 1.135 0 0 1 1.546 1.664zm.903-2.165l7.3 8.7c-1.581-1.296-3.411-2.45-5.517-3.437l-6.819-3.188 1.682-2.07.034-.042a2.14 2.14 0 0 1 3.32.037z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01182B",
    d: "M153.717 128.734a.81.81 0 1 1 1.51-.59.81.81 0 0 1-1.51.59m-.84.329a1.711 1.711 0 1 1 3.187-1.248 1.711 1.711 0 0 1-3.187 1.248",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E4E4E",
    d: "M169.37 118.618l-11.858 6.755 1.147 2.012 11.35-6.467-.489-1.181a1.676 1.676 0 0 1-.086-.207v-.002a1.786 1.786 0 0 1-.065-.91",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0171B7",
    d: "M171.906 119.773a1.136 1.136 0 0 1-1.568-1.643 1.136 1.136 0 0 1 1.568 1.643zm-2.386-.036a1.707 1.707 0 0 1-.086-.206v-.003a1.782 1.782 0 0 1 1.304-2.318l9.705-1.964-10.148 6.36-.775-1.87zM152.695 134.641l1.89-4.493a1.72 1.72 0 0 1-1.412-.593l-1.889 4.494a1.714 1.714 0 0 1 1.411.592",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M146.017 132.213a1.135 1.135 0 1 1 2.085.898 1.135 1.135 0 0 1-2.085-.898M145.526 137.71a1.136 1.136 0 1 1 2.086.898 1.136 1.136 0 0 1-2.086-.898",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01182B",
    d: "M220.474 144.223a1.135 1.135 0 1 1-1.663 1.544 1.135 1.135 0 0 1 1.663-1.544m1.05-.975a2.567 2.567 0 1 1-3.764 3.494 2.569 2.569 0 0 1 3.764-3.494",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0171B7",
    d: "M220.474 144.223a1.135 1.135 0 1 1-1.663 1.544 1.135 1.135 0 0 1 1.663-1.544",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01182B",
    d: "M213.39 134.405a1.134 1.134 0 1 1-1.664 1.544 1.135 1.135 0 0 1 1.664-1.544M181.5 125.3a1.136 1.136 0 0 1-1.569-1.641 1.136 1.136 0 0 1 1.569 1.642M189.46 116.36a1.135 1.135 0 1 1-1.663 1.545 1.135 1.135 0 0 1 1.663-1.544m.941 2.629a2.567 2.567 0 1 1 .085-3.63 2.566 2.566 0 0 1-.085 3.63",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0171B7",
    d: "M189.46 116.36a1.134 1.134 0 1 1-1.662 1.545 1.134 1.134 0 0 1 1.662-1.544",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01182B",
    d: "M171.906 119.773a1.136 1.136 0 0 1-1.568-1.643 1.136 1.136 0 0 1 1.568 1.643",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0171B7",
    d: "M153.717 128.734a.81.81 0 1 1 1.51-.59.81.81 0 0 1-1.51.59",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01182B",
    d: "M151.956 136.343a.81.81 0 1 1-1.12-1.172.81.81 0 0 1 1.12 1.172m-2.154.037a1.711 1.711 0 1 1 3.19-1.248 1.711 1.711 0 0 1-3.19 1.248",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0171B7",
    d: "M151.956 136.343a.81.81 0 1 1-1.12-1.172.81.81 0 0 1 1.12 1.172",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D3E43",
    d: "M231.549 181.677h-12.41a67.463 67.463 0 0 1-.155-6.654l15.802-3.167c-1.931.387-3.094 1.492-3.094 3.222l-.143 6.6z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F7380",
    d: "M218.984 175.022c.1-3.6 1.104-8.028 2.519-12.409l15.938-.494 1.594 8.886-20.05 4.017z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74A6AA",
    d: "M227.223 162.433l3.323-.1-4.081 11.19-3.546.712z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87C3C8",
    d: "M224.908 162.507l1.464-.045-4.36 11.954-1.562.313z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406061",
    d: "M220.203 181.677h3.288l2.974-8.153-3.546.71z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#517C74",
    d: "M219.14 181.677h.223l2.65-7.261-.348.07-1.216.243-1.459 4c.03.976.08 1.955.15 2.948",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0171B7",
    d: "M239.035 181.677h-7.486l.143-6.599c0-1.73 1.163-2.835 3.094-3.221l4.25-.852v10.672z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M209.252 187.128l15.27-1.482H241l15.27 1.482a4.934 4.934 0 0 1-.477 9.844h-46.085a4.934 4.934 0 0 1-.456-9.844z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353635",
    d: "M255.794 195.546a3.508 3.508 0 0 0 .339-6.999l-15.202-1.474h-16.34l-15.201 1.475v-.001a3.508 3.508 0 0 0 .334 6.998h46.07zm-46.086 1.426a4.935 4.935 0 0 1-4.914-4.934 4.935 4.935 0 0 1 4.458-4.91l15.27-1.482H241l15.27 1.482a4.935 4.935 0 0 1 4.46 4.91 4.935 4.935 0 0 1-4.936 4.934h-46.086z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7B7B7",
    d: "M240.931 187.072a1.403 1.403 0 1 1 0 2.807 1.403 1.403 0 0 1 0-2.807M232.761 192.74a1.403 1.403 0 1 1 0 2.806 1.403 1.403 0 0 1 0-2.807M237.101 192.74a1.403 1.403 0 1 1 0 2.806 1.403 1.403 0 0 1 0-2.807M224.592 187.072a1.403 1.403 0 1 1 0 2.807 1.403 1.403 0 0 1 0-2.807M241.441 192.74a1.403 1.403 0 1 1 0 2.806 1.403 1.403 0 0 1 0-2.807M245.78 192.74a1.403 1.403 0 1 1 .002 2.806 1.403 1.403 0 0 1-.001-2.807M250.12 192.74a1.403 1.403 0 1 1 .001 2.806 1.403 1.403 0 0 1 0-2.807M215.402 192.74a1.403 1.403 0 1 1 0 2.806 1.403 1.403 0 0 1 0-2.807M219.742 192.74a1.403 1.403 0 1 1 0 2.806 1.403 1.403 0 0 1 0-2.807M224.082 192.74a1.403 1.403 0 1 1 0 2.806 1.403 1.403 0 0 1 0-2.807M228.421 192.74a1.403 1.403 0 1 1 .001 2.806 1.403 1.403 0 0 1 0-2.807M209.729 189.073a2.966 2.966 0 1 1 .001 5.932 2.966 2.966 0 0 1-.001-5.932M255.794 189.073a2.965 2.965 0 1 1 0 5.931 2.965 2.965 0 0 1 0-5.93",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    d: "M256.512 190.068a2.097 2.097 0 1 1-1.437 3.94l1.437-3.94z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#686868",
    d: "M212.008 193.937h23.597l1.658-4.548h-26.2a2.965 2.965 0 0 1 .945 4.548M255.794 189.941c.252 0 .494.045.718.127l-1.437 3.94a2.098 2.098 0 0 1 .719-4.067",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    d: "M210.448 190.068a2.097 2.097 0 1 1-1.438 3.94l1.438-3.94z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#686868",
    d: "M209.729 189.941c.253 0 .495.045.719.127l-1.438 3.94a2.098 2.098 0 0 1 .719-4.067",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    d: "M235.604 193.937h17.911a2.964 2.964 0 0 1 .944-4.547h-17.196l-1.659 4.547z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0171B7",
    d: "M170.563 130.292l-16.143 6.318 2.39-6.555 14.457-9.059 3.482-2.182z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1DDD4",
    d: "M250.689 156.928a3.4 3.4 0 1 1-3.401 3.4 3.4 3.4 0 0 1 3.4-3.4",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1DDD4",
    d: "M246.571 150.665a4.117 4.117 0 1 1-4.117 4.116 4.117 4.117 0 0 1 4.117-4.116",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1DDD4",
    d: "M252.658 138.362a7.742 7.742 0 0 1 7.743 7.74 7.742 7.742 0 0 1-7.743 7.74 7.741 7.741 0 0 1-7.743-7.74 7.741 7.741 0 0 1 7.743-7.74",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4D596",
    d: "M90.838 196.971c7.123-13.005 20.555-19.853 30.613-19.853v19.853H90.838z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8AA50",
    d: "M152.063 196.971c-7.123-13.005-20.555-19.853-30.613-19.853v19.853h30.613z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4D596",
    d: "M124.303 192.169a1.181 1.181 0 1 1 0 2.362 1.181 1.181 0 0 1 0-2.362M136.721 192.2a.737.737 0 1 1 0 1.474.737.737 0 0 1 0-1.475M128.51 194.208a.737.737 0 1 1 0 1.475.737.737 0 0 1 0-1.475M125.597 188.236a.738.738 0 1 1 0 1.475.738.738 0 0 1 0-1.475",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8AA50",
    d: "M115.054 189.442a1.593 1.593 0 1 1 .002 3.187 1.593 1.593 0 0 1-.002-3.187M110.39 184.94a1.025 1.025 0 1 1 0 2.05 1.025 1.025 0 0 1 0-2.05M117.775 193.194a1.229 1.229 0 1 1 .001 2.458 1.229 1.229 0 0 1 0-2.458M105.54 193.208a.902.902 0 1 1-.001 1.803.902.902 0 0 1 0-1.803M109.604 190.469a1.116 1.116 0 1 1 0 2.233 1.116 1.116 0 0 1 0-2.233M118.737 186.24a.88.88 0 1 1 0 1.761.88.88 0 0 1 0-1.76M113.742 193.576a.737.737 0 1 1 0 1.474.737.737 0 0 1 0-1.474M98.64 190.971a.697.697 0 1 1 0 1.394.697.697 0 0 1 0-1.394",
    mask: "url(#b)"
  })))));
};
export default SvgB2B;